module.exports = __webpack_public_path__ + "static/media/piano-c.47e24eed.wav";